import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { EventUtil } from "../../util/EventUtil";
import { SpecialtySelect } from "../healioGlobal/SpecialtySelect";
import { SubSpecialtySelect } from "../healioGlobal/SubSpecialtySelect";
import { ViewBySubSpecialty } from "./ViewBySubSpecialty";

export class ViewBySpecialty extends Component {

    private _selectedSpecialty = "";

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
    }

    public async init(): Promise<void> {
        let context = this._pageContext;
        if (!context) {
        throw new Error("No page context");
        }

        let selectedSpecialty = this._element.dataset.specialtyId;
        if(selectedSpecialty){
            this._selectedSpecialty = selectedSpecialty;
        }

        // re-using this event since the landing card layout is already listening for it
        this._element.dispatchEvent(EventUtil.createCustomEvent(SpecialtySelect.SpecialtySelectInitEvent, null));

        // check for subspecialty component, if it's not added then just emit the subspecialty select too. In the old selects we
        // would just add it to the page and leave it hidden
        const subspecialtySelect: ViewBySubSpecialty | null = context.componentFactory.getComponent(ViewBySubSpecialty);
        if(subspecialtySelect){
            this._element.dispatchEvent(EventUtil.createCustomEvent(SubSpecialtySelect.SubSpecialtySelectInitEvent, null));
        }
    }

    public get specialty(): string {
        return this._selectedSpecialty;
    }

    public get element() : HTMLElement {
        return this._element;
    }
}

ComponentFactory.registerComponent("ViewBySpecialty", ViewBySpecialty);
